import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_PLAN_DETAIL_ASYNC,
  GET_PLAN_DETAIL_REQUEST_SUCCESS,
  GET_PLAN_DETAIL_REQUEST_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getPlanDetailSaga(action) {
  try {
    const result = yield call(api.getPlanDetailRequest, action.payload)

    yield put({
      type: GET_PLAN_DETAIL_REQUEST_SUCCESS,
      payload: result.data,
    })
  } catch (error) {
    yield put({ type: GET_PLAN_DETAIL_REQUEST_FAILURE, error })
  }
}

export function* getPlanDetailWatcherSaga() {
  yield takeLatest(GET_PLAN_DETAIL_ASYNC, getPlanDetailSaga)
}
